import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import SvgIcon from '@/components/SvgIcon/index.vue'; // svg component
// register globally
export const registerSvgIcon = app => {
  app.component('svg-icon', SvgIcon);
  const req = require.context('./svg', false, /\.svg$/);
  // eslint-disable-next-line
  const requireAll = requireContext => requireContext.keys().map(requireContext);
  requireAll(req);
};